<template>
  <div class="grid grid-cols-3 gap-1">
    <!-- TITLE -->
    <div class="col-span-3 flex gap-7 bg-blue-10 p-4">
      <div class="w-full">
        <h2 class="max-w-text hyphens-auto">{{ data.title }}</h2>
      </div>

      <!-- DOWNLOAD BUTTON -->
      <DownloadButton
        :loading="isLoading"
        :aria-label="`${$t('accessibility.download_document')}: ${data.title}`"
        class="h-4 w-4 shrink-0 translate-y-1 text-blue-800 hover:text-blue-dark"
        @click="downloadFile"
      />
    </div>

    <!-- AUTHOR -->
    <div class="bg-blue-10 p-4">
      <p class="text-sm opacity-60">{{ $t('author') }}</p>
      <p class="hyphens-auto">
        {{ data.author }}
      </p>
    </div>
    <!-- YEAR -->
    <div class="bg-blue-10 p-4">
      <p class="text-sm opacity-60">{{ $t('year') }}</p>
      <p>{{ data.year }}</p>
    </div>
    <!-- LANGUAGE -->
    <div class="bg-blue-10 p-4">
      <p class="text-sm opacity-60">{{ $t('language') }}</p>
      <p>
        <template v-for="(language, index) in data.languages" :key="language">
          {{ language }}{{ index < data.languages.length - 1 ? ',&nbsp;' : '' }}
        </template>
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: null },
})

// VARIABLES
const isLoading = ref(false)

// FUNCTIONS
function downloadFile() {
  isLoading.value = true
  fetch(props.data.url)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob)
      const sanitizedTitle = sanitizeFilename(props.data.title)
      const a = document.createElement('a')
      a.href = url
      a.download = `${sanitizedTitle}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      isLoading.value = false
    })
}
function sanitizeFilename(title) {
  return title.replace(/[/\\?%*:|"<>]/g, '')
}
</script>
